import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-expertise',
  templateUrl: './expertise.component.html',
  styleUrls: ['./expertise.component.scss'],
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertiseComponent {
  public readonly expertises = [
    {
      name: 'main_page.expertise.implementations',
      number: '2K+',
      image: 'activity.svg',
    },
    {
      name: 'main_page.expertise.sessions',
      number: '250M+',
      image: 'clipboard.svg',
    },
    {
      name: 'main_page.expertise.countries',
      number: '20+',
      image: 'globe.svg',
    },
    {
      name: 'main_page.expertise.retention',
      number: '90%',
      image: 'anchor.svg',
    },
    {
      name: 'main_page.expertise.expansion',
      number: '3.2X',
      image: 'flag.svg',
    },
  ];
}
